/// <amd-module name="typeahead/features/IncreaseMobileFontSize" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const emptyString = "";
const fontSizeProperty = "font-size:";
const fontSizeUnit = "em";

const largeFontBoost = "1.077";
const largestFontBoost = "1.231";

const largeConfig: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage"],
        lobs: ["FLIGHTS"],
    },
];

const largestConfig: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "CarsLandingPage"],
        lobs: ["CARS"],
    },
];
const allConfigs = [largeConfig, largestConfig];

export class IncreaseMobileFontSize implements IExperimentalFeature, ISuggestionsModifier {
    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments([].concat.apply([], allConfigs));
    }
    public modifySuggestions(suggestions: any, context: IContext, options: any): object[] {
        let fontSizeBoost = emptyString;
        if (TypeaheadUtils.isWithinMobileBreakpoint()
                && suggestions && suggestions.length > 0) {
            if (ExecutionHelper.shouldExecute(context, largeConfig)) {
                fontSizeBoost = largeFontBoost;
            }
            if (ExecutionHelper.shouldExecute(context, largestConfig)) {
                fontSizeBoost = largestFontBoost;
            }
            if (fontSizeBoost !== emptyString) {
                suggestions.forEach((sr): void => {
                    sr.style = `${fontSizeProperty}${fontSizeBoost}${fontSizeUnit}`;
                });
            }
        }
        return suggestions;
    }
}
